import React, { Component, useEffect, useState } from 'react';
import { withTranslation, Trans, withNamespaces } from 'react-i18next';
import axios from 'axios';

import CustomListModal from './CustomListModal'

const AddToListButton = ({ jwt, api_origin, api_url, data }) => {

    const [ open, setOpen ] = useState(false);
    const [ savedList, setSavedList ] = useState();

    const openListModal = async() => {
        
        let list = await axios.get(api_url+`/lists`, 
            {   
                headers: {
                    "Accept": "application/json, text/javascript, */*; q=0.01",
                    "Authorization": jwt
                }
            }
        );

        if (list) {
            setSavedList(list.data.data);
            setOpen(true);
        }

    }

    const setIsOpenBack = async() => {
        setOpen(false);
    }

    return(
        <>
            <li className="cardBtnLi">
                <a className=" folder-icon prd-in-card" onClick={(e) => openListModal(e)} >
                    <img className="liImg" src="/img/svgs/folder-plus-icon.svg" alt="copy-icon" />
                </a>
            </li>

            <CustomListModal 
                isOpen={open}
                jwt={jwt} 
                api_origin={api_origin}
                api_url={api_url}
                savedList={savedList}
                product_id={data.id.raw}
                setIsOpenBack={setIsOpenBack}
                data={data}
            />
        </>
    );

}

export default withTranslation()(AddToListButton); 